var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    transform: "matrix(-1 0 0 1 48.8325 0)",
    fill: "#236F5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.51 30.9217C22.9165 28.5104 25.3034 26.1186 27.7001 23.7316C27.8466 23.5852 27.8808 23.5071 27.7099 23.3411C26.9582 22.6138 26.2162 21.867 25.484 21.1202C25.2888 20.92 25.1521 20.9054 24.9471 21.1153C22.6724 23.3997 20.3929 25.6793 18.1133 27.9539C17.923 28.1443 17.8693 28.2761 18.0889 28.4909C18.9041 29.2914 19.6997 30.1017 20.5149 30.9266L20.51 30.9217Z",
    fill: "#C7D0CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0854 30.9951C29.335 30.9951 30.5797 30.9951 31.8293 30.9951C31.8293 28.5886 31.8244 26.1773 31.8196 23.7708C31.2143 23.6634 30.609 23.7269 30.0037 23.7269C29.3692 23.7269 28.7297 23.6634 28.0952 23.7708C28.0952 26.1822 28.0903 28.5886 28.0854 31L28.0854 30.9951Z",
    fill: "#C7D0CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.055 20.6561C25.055 19.4358 25.055 18.2203 25.0599 17C22.6534 17 20.2469 17 17.8356 17C17.8356 18.2203 17.8356 19.4358 17.8405 20.6561C20.242 20.6561 22.6485 20.6561 25.0501 20.6561L25.055 20.6561Z",
    fill: "#C7D0CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0967 20.6561C29.3414 20.6561 30.5812 20.6561 31.826 20.6561C31.826 19.4358 31.826 18.2154 31.826 17C30.5812 17 29.3365 17 28.0967 17C28.0967 18.2203 28.0967 19.4406 28.0967 20.661L28.0967 20.6561Z",
    fill: "#C7D0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBtn);
export default __webpack_public_path__ + "static/media/side-btn.fe854ed5aa6dbf72e2879637c9c654e8.svg";
export { ForwardRef as ReactComponent };